
<template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Ανταλλακτικά</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lineItems"
      :search="search"
      loading: false
      item-key="lid"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      show-group-by
      :expanded.sync="expanded"
    >
<template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :to="{name: 'quote-create', query: {cid: $route.params.gid}} "
            >
              Νεα Προσφορα
            </v-btn>
      </v-toolbar>
    </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="'/quote/'+item.lid.split('@')[0]+'/edit'"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.litem.price="{ item }">
       {{ tocurr(item.litem.price) }}
    </template>
     <template v-slot:item.netvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty) }}
    </template>
    <template v-slot:item.totalvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*1.24) }}
    </template>
    <template v-slot:item.vatvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*0.24) }}
    </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.quoteid }}
      </td>
    </template>



    </v-data-table>
  </v-card>
</template>


<script>

export default {
  components: {
 //   QuoteCard
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: '',
      customer_id: this.$route.params.gid,
      lineItems: [],
      headers: [
          {
            text: 'Προσφορά',
            align: 'start',
            //sortable: false,
            groupable: false,
            value: 'lid',
            width: '10%',
          },
          { text: 'Κωδικός', value: 'vehicle', width: '10%' },
          { text: 'Κωδικός', value: 'litem.sku', width: '10%' },
          { text: 'Περιγραφή', value: 'litem.description' },
        { text: 'Ποσότητα', value: 'litem.qty', align: 'center', groupable: false  },
        { text: 'Μονάδα Μέτρησης', value: 'litem.unit', align: 'center', groupable: false  },
        { text: 'Τιμή', value: 'litem.price', align: 'end', groupable: false  },
        { text: 'Καθαρή αξία', value: 'netvalue', align: 'end', groupable: false  },
          { text: 'ΦΠΑ', value: 'vatvalue', align: 'end', groupable: false },
          { text: 'Συνολο', value: 'totalvalue', align: 'end', groupable: false},
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand', groupable: false },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/quotes/bycustomer/'+this.$route.params.gid+ '/items');
        console.log(response);
        this.lineItems = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  }
}
</script>
